<template>
  <div id="tags-view-container" class="tags-view-container">
    <div class="tags-view-wrapper" >
      <i class="el-tabs__nav-prev el-icon-arrow-left icon" :class="{'disabled':isFirst}" @click="onLeft"></i>
      <div class="tags-view-wrapper-tabs" ref="scrollPane">
        <div class="tags-view-wrapper-nav" ref="nav" :style='navStyle'>
        <template v-if="visitedViews && visitedViews.length !== 0">
        <router-link
          v-for="tag in visitedViews"
          ref="tag"
          :key="tag.path"
          :class="isActive(tag)?'active':''"
          :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
          tag="span"
          class="tags-view-item"
          @click.middle.native="!isAffix(tag)?closeSelectedTag(tag):''"
          @contextmenu.prevent.native="openMenu(tag,$event)"
        >
          {{ tag.title }}
          <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
        </router-link>
        </template>
        </div>
      </div>
      <i class="el-tabs__nav-next el-icon-arrow-right icon" :class="{'disabled':isLast}"  @click="onRight"></i>
    </div>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">刷新</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">关闭</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane'
import path from 'path'

export default {
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      newOffset:0,
      navOffset:0,
      scrollable: false, // 是否可以点击滚动
      firstScroll:false,
      tabPosition:'top',
      width: void 0, // 内部宽度
      isLast: false, // 是否是最后
      isFirst: false // 是否是初始
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$router.options.routes // this.$store.state.permission.routes
    },
    navStyle() {
      var dir = ['top', 'bottom'].indexOf(this.tabPosition) !== -1 ? 'X' : 'Y';
      return {
        transform: 'translate' + dir + '(-' + this.navOffset + 'px)'
      };
    },
    sizeName: function sizeName() {
      return ['top', 'bottom'].indexOf(this.tabPosition) !== -1 ? 'width' : 'height';
    }
  },
  watch: {
    $route() {
      try{
      this.initTags()
      this.addTags()
      }catch(e){
        console.log('异常watch----',e)
      }
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.initTags()
    this.addTags()
    
  },
  methods: {
    
    //左移
    onLeft(){
      if(!this.firstScroll) return 
      
      var containerSize = this.$refs.scrollPane['offset' + this.firstUpperCase(this.sizeName)];
      // var scrollSize = this.$refs.nav['offset' + this.firstUpperCase(this.sizeName)];
      var currentOffset = this.navOffset ;

      if (!currentOffset) return;

      var newOffset = currentOffset > containerSize? currentOffset - containerSize : 0;
      if(newOffset === 0){
         this.firstScroll = false
         this.isFirst = true
         this.isLast = false
         this.scrollable = true
      }
      this.navOffset = newOffset;
    },
    //右移
    onRight(){
      if(!this.scrollable) return 
      var navSize = this.$refs.nav['offset' + this.firstUpperCase(this.sizeName)];
      var containerSize = this.$refs.scrollPane['offset' + this.firstUpperCase(this.sizeName)];
      var currentOffset = this.navOffset;

      if (navSize - currentOffset <= containerSize) return;

      var newOffset = navSize - currentOffset > containerSize * 2 ? currentOffset + containerSize : navSize - containerSize;
      if(newOffset <= 0) this.firstScroll = true
      else {
        this.firstScroll = true
        this.isLast = true
        this.isFirst = false
      }
      this.navOffset = newOffset;
    },
    isActive(route) {
      
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    filterAffixTags(routes, basePath = '/') {
      // console.log(routes)
      let tags = []
      
      if(routes && routes.length !== 0){
       
      routes.forEach(route => {
        // console.log(route.path)
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          console.log('path---',tagPath)
          console.log('basePath---',basePath)
          console.log('route.path---',route.path)
          console.log('==.path---',tags.some(v => v.path === tagPath))
          

          // if(tags.some(v => v.path === tagPath)) throw '已存在'
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
        
      })
      }
      
      return tags
      
    },
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes)
      if(affixTags && affixTags.length !== 0){
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
      }
      this.width = this.$refs.nav.offsetWidth
      const pd = this.$refs.scrollPane.offsetWidth
      if(pd < this.width) {
        this.firstScroll = true
        // this.scrollable = true
      }
    },
    addTags() {
      
      const { name } = this.$route
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      const activeTab = this.$el.querySelector('.active');
      const nav = this.$refs.nav;
      const scrollPane = this.$refs.scrollPane;
      if (!activeTab) return false
      const activeTabBounding = activeTab.getBoundingClientRect();
      const scrollPaneBounding = scrollPane.getBoundingClientRect();
      const navBounding = nav.getBoundingClientRect();
        const maxOffset = nav.offsetWidth - scrollPaneBounding.width;
      const currentOffset = this.navOffset// activeTabBounding.width
      // console.log('scrollPane',scrollPaneBounding)
      // console.log('nav',navBounding)
      // console.log('activeTab',activeTabBounding)
      let newOffset = currentOffset
        if (activeTabBounding.left < navBounding.left) {
          newOffset = currentOffset - (navBounding.left - activeTabBounding.left);
        }
        if (activeTabBounding.right > navBounding.right) {
          newOffset = currentOffset + activeTabBounding.right - navBounding.right;
        }else{
            if(currentOffset === 0){
              if(activeTabBounding.left < scrollPaneBounding.width) {
                newOffset = 0
                if(nav.offsetWidth < scrollPane.offsetWidth) this.isLast = true
                else this.isLast = false
                this.isFirst = true
                this.firstScroll = false
                this.scrollable = true
              }
              else {
                newOffset = navBounding.width - activeTabBounding.width;
                  this.isLast = true
                  this.isFirst = false
                  this.scrollable = false
                  this.firstScroll = true
              }
            }
        }
        
        // if(newOffset === currentOffset) {
        //     this.isLast = false
        //     if(navBounding.left < 0)this.isFirst = false
        //     else this.isFirst = true
        //     if(navBounding.width > scrollPaneBounding.width) this.scrollable = true
        // }
        // if ( navBounding.right - activeTabBounding.right <= currentOffset) {
        //   newOffset = currentOffset + activeTabBounding.right - navBounding.right;
        //   this.isLast = true
        // }else this.isLast = false
        newOffset = Math.max(newOffset, 0);
        this.navOffset = Math.min(newOffset, maxOffset);
      // return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            // this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        // this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft + 200
      } else {
        this.left = left + 200
      }

      this.top = e.clientY + 5
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    handleScroll() {
      this.closeMenu()
    },
    firstUpperCase(str){
      return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
        return L.toUpperCase();
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 34px;
  width: 100%;
  background: transparent;
  // border-bottom: 1px solid #d8dce5;
  // box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
  .tags-view-wrapper {
    position: relative;
    margin:0 20px;
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 26px;
      line-height: 26px;
      // border: 1px solid #d8dce5;
      color: #808695;
      background: #fff;
      padding: 0 8px;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 4px;
      border-radius: 3px;
      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        background-color: #fff;
        color: $primary;
        border-color: transparent;
        &::before {
          content: '';
          background: #fff;
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 2px;
        }
      }
    }
    /deep/ .el-tabs__nav-next, .el-tabs__nav-prev{
      line-height: 36px !important;
      top:0;
    }
    /deep/ .active::before{
      display: none !important;
    }
    
    
  }
  .tags-view-wrapper-tabs{
    width:calc(100% - 30px);
    margin:0 auto;
    display: block;
    overflow: hidden;
  }
  .tags-view-wrapper-nav{
        white-space: nowrap;
    position: relative;
    transition: transform .3s;
    float: left;
    z-index: 2;
    box-sizing: border-box;
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;
      &:before {
        transform: scale(.6);
        display: inline-block;
        vertical-align: -3px;
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
.icon{
  cursor: pointer;
}
.disabled{
  color:#ccc !important;
  cursor:not-allowed !important;
}
.tags-view-container .tags-view-wrapper .tags-view-item:first-of-type{
  margin-left:0 !important;
}
</style>
